import { Link } from 'react-router-dom';
import { FileText, LogOut, Printer } from 'lucide-react';
import { tr } from '@/lib/i18n-core';
import { useAuth } from '@/lib/auth';
import { dateTime } from '@/lib/utils';
import { Button } from '@/components/ui/primitives';
import { ShellEmpty, ShellPanel, ShellSectionHeading } from '@/components/clinical-shell/ShellPanel';
import { admissionIsOpen, ipdEmrPath, type Admission } from '../../admission/types';
import { useAdmissionPrints } from '../../admission/sections/DocumentsSection';

export function DischargeSummarySection({ admission }: { admission: Admission }) {
  const { can } = useAuth();
  const { printDoc } = useAdmissionPrints(admission.id);
  const current = admissionIsOpen(admission);
  const dischargeTo = `/ipd/admissions/${admission.id}/discharge?returnTo=${encodeURIComponent(ipdEmrPath(admission.id, 'discharge-summary'))}`;

  return (
    <>
      <ShellSectionHeading icon={FileText} title={tr('ipd', 'discharge_summary')} description={tr('ipd', 'ws_discharge_summary_desc')} />
      <ShellPanel
        icon={FileText}
        title={current ? tr('ipd', 'ws_written_at_discharge') : tr('ipd', 'ws_signed_summary')}
        actions={
          current ? (
            can('admission.manage') ? (
              <Link to={dischargeTo}>
                <Button size="sm">
                  <LogOut className="h-4 w-4" aria-hidden /> {tr('ipd', 'discharge')}
                </Button>
              </Link>
            ) : null
          ) : (
            <Button size="sm" variant="outline" onClick={() => printDoc.mutate('summary')} loading={printDoc.isPending}>
              <Printer className="h-4 w-4" aria-hidden /> {tr('ipd', 'print')}
            </Button>
          )
        }
      >
        {current ? (
          <ShellEmpty>{tr('ipd', 'ws_summary_written_at_discharge_desc')}</ShellEmpty>
        ) : (
          <p className="text-sm text-muted-foreground">{tr('ipd', 'ws_left_on_x', { date: dateTime(admission.dischargedAt) })}</p>
        )}
      </ShellPanel>
    </>
  );
}
